import { render, staticRenderFns } from "./DraggableWindow.vue?vue&type=template&id=f8abba30&scoped=true&"
import script from "./DraggableWindow.vue?vue&type=script&lang=js&"
export * from "./DraggableWindow.vue?vue&type=script&lang=js&"
import style0 from "./DraggableWindow.vue?vue&type=style&index=0&id=f8abba30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8abba30",
  null
  
)

export default component.exports